import React from 'react';
import SwiperCore, { Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import styled from 'styled-components';

import 'swiper/swiper.min.css';
import 'swiper/components/pagination/pagination.min.css';
import './styles.scss';

import { stripTags } from 'app/utils';
import { HeaderState } from 'features/headers';

import { Box, Button, Flex, Section, Typography } from 'components';

SwiperCore.use([Pagination]);

const SquareLines = styled('i')`
  position: relative;
  position: absolute;
  left: 0;
  width: 0px;
  height: 0px;

  &::after {
    content: '';
    display: block;
    background-color: ${({ theme }) => theme.colors.primary_200};
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1000;
  }

  ${({ theme: { mediaQueries } }) => {
    return `
        ${mediaQueries.mobile} {
          top: 1px;

          &::after {
            width: 14px;
            height: 14px;
          }

          &::before {
            top: -40px;
            width: 150px;
            height: 300px;
          }
        }

        ${mediaQueries.tablet} {
          top: 1px;

          &::after {
            width: 18px;
            height: 18px;
          }

          &::before {
            top: -40px;
            width: 300px;
            height: 400px;
          }
        }

        ${mediaQueries.desktop} {
          top: 4px;

          &::after {
            width: 24px;
            height: 24px;
          }

          &::before {
            top: -75px;
            width: 1000px;
            height: 500px;
          }
        }
      `;
  }}
`;

const HeaderOverlay = styled(Flex)`
  width: 100%;
  height: 100%;
  background: url('/images/headerOverlay.png');
  background-size: cover;
`;

interface CarouselProps {
  headers: HeaderState[];
}

const Carousel = ({ headers }: CarouselProps) => {
  return (
    <Swiper
      slidesPerView={1}
      loop={false}
      autoplay={{
        delay: 1000,
      }}
      pagination={{
        clickable: true,
        renderBullet: (index: any, className: any) => {
          return '<div class="' + className + '"></div>';
        },
      }}
      className="home-headers"
    >
      {headers.length &&
        headers.map((header, index) => {
          const hasHat = !!stripTags(header?.hat)?.length;

          return (
            <SwiperSlide key={header.uuid}>
              <Flex
                width="100%"
                height="100%"
                overflow="hidden"
                backgroundImage={`url('${header.backgroundImageUrl}')`}
                backgroundSize="cover"
                backgroundPosition="center"
                data-carousel-wrapper
              >
                <HeaderOverlay>
                  <Section position="relative" alignItems="center">
                    <Flex position="relative" flexGrow={0} flexDirection="column" pl={{ m: 20, t: 40 }} maxWidth={{ d: 700 }}>
                      <SquareLines />

                      {hasHat && (
                        <Typography type="type6" fontWeight="bold" color="white">
                          {header.hat}
                        </Typography>
                      )}

                      {!!stripTags(header?.name)?.length && (
                        <Typography type="type9" fontWeight="bold" color="white" mt={hasHat ? { m: '10px', t: 15 } : '-13px'}>
                          {header.name}
                        </Typography>
                      )}

                      {Boolean(header.linkLabel) && (
                        <Box mt={4}>
                          <a href={header.linkUrl} target="_blank" rel="noreferrer">
                            <Button>{header.linkLabel}</Button>
                          </a>
                        </Box>
                      )}
                    </Flex>
                  </Section>
                </HeaderOverlay>
              </Flex>
            </SwiperSlide>
          );
        })}
    </Swiper>
  );
};

export default Carousel;
